import React, { useEffect, useState } from 'react';
import { getHomeBlogPosts } from '../../../api/services/blogPostsApi';

import { ImQuotesLeft, ImQuotesRight } from 'react-icons/im';

import './Home.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

// ---- Image Imports ----
import mva from '../../../images/main/mva-services.webp';

// -- Main banner --
import HomeHeroBanner from '../../../components/main/home/HomeHeroBanner/HomeHeroBanner';
import HomeBlogSlider from '../../../components/main/home/HomeBlogSlider/HomeBlogSlider';

// -- Statement --

// -- Insurance --
import HomeInsurance from '../../../components/main/home/HomeInsurance/HomeInsurance';

// -- Process --
import HomeProcess from '../../../components/main/home/HomeProcess/HomeProcess';

// -- Services --
import HomeServices from '../../../components/main/home/HomeServices/HomeServices';

// -- MVA Services --
import Button from '../../../components/main/buttons/Button/Button';

// -- Our Facilities --
import HomeFacilities from '../../../components/main/home/HomeFacilities/HomeFacilities';

// -- Testimonials --
import Testimonials from '../../../components/main/home/Testimonials/Testimonials';

function Home() {
  const [blogPosts, setBlogPosts] = useState([]);
  const [isLoadingBlogPosts, setIsLoadingBlogPosts] = useState(true);

  useEffect(() => {
    const fetchBlogPosts = async () => {
      setIsLoadingBlogPosts(true);

      try {
        const res = await getHomeBlogPosts({
          page: 1,
          limit: 6, // control slider size
        });

        setBlogPosts(res.data || []);
      } catch (err) {
        console.error('Error fetching blog posts:', err);
      } finally {
        setIsLoadingBlogPosts(false);
      }
    };

    fetchBlogPosts();
  }, []);

  return (
    <div className='homePage-container'>
      {!!blogPosts.length && <HomeBlogSlider posts={blogPosts} />}
      {!isLoadingBlogPosts && !blogPosts.length && <HomeHeroBanner />}

      {/* ---- insurance section - home page ----- */}
      <HomeInsurance />

      {/* ---- statement section - home page ----- */}
      <div className='homePage-statement'>
        <h1>REHAB. PERFORMANCE. RECOVERY</h1>
        <div className='statement-bubble'>
          <div className='quoteLeft-container'>
            <ImQuotesLeft style={{ fontSize: '30px' }} />
          </div>
          <div className='statement'>
            Our goal at Pro Evolution Wellness is management. We not only take
            pride in helping patients reduce pain, improve strength and restore
            mobility, but also to educate our patients on how to manage their
            condition so that they can achieve long-term health benefits. Our
            combined approaches of patient care and patient education ensures
            that we achieve our overall goal
          </div>
          <div className='quoteRight-container'>
            <ImQuotesRight style={{ fontSize: '30px' }} />
          </div>
        </div>
      </div>

      {/* ---- process section - home page ----- */}
      <HomeProcess />

      {/* ---- our services section - home page ----- */}
      <HomeServices />

      {/* ---- mva services section - home page ----- */}
      <div className='mva-container'>
        <div className='mva-title'>
          <h1>Motor Vehicle Accident (MVA) Services</h1>
        </div>
        <div className='mva-img-container'>
          <img src={mva} alt='banner' className='banner-img' />
        </div>
        <div className='mva-subText'>
          <p>
            Pro Evolution Wellness Clinic is an HCAI facility and a licensed
            provider for auto insurance rehabilitation in Ontario.
          </p>
          <p>
            We provide professional clinical treatment for people injured in
            vehicle-related accidents.
          </p>
        </div>
        <div className='mva-button-container'>
          <Button
            href='https://proevolutionwellness.janeapp.com/'
            className='mva-button'
          >
            Book Now
          </Button>
        </div>
      </div>

      {/* ---- our facilities section - home page ---- */}
      <HomeFacilities />

      {/* ---- our location section - home page ---- */}
      <div className='locations-container'>
        <div className='locations-title'>
          <h1>OUR LOCATION</h1>
        </div>
        <div className='locations-img'>
          <iframe
            title='proEvolution'
            src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2877.594703490833!2d-79.56786758394337!3d43.84350097911519!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b2531610a3123%3A0xbb1dcdb52405cb2b!2sPro%20Evolution%20Wellness!5e0!3m2!1sen!2sca!4v1678209951368!5m2!1sen!2sca'
            loading='lazy'
            referrerPolicy='no-referrer-when-downgrade'
          ></iframe>
        </div>
      </div>

      {/* ---- testimonials section - home page ----- */}
      <Testimonials />
    </div>
  );
}

export default Home;
